import './latest.scss'
import { useQuery } from 'react-query'
import { useMutation } from 'react-query';
import { Link } from 'react-router-dom';
import api  from "../../services/api";

const fetchTargets = async () => {
  const res = await api.get(`/api/osint/target/`)
  return res.data.results
}



const FollowList = () => {
    const {
        data: targets,
        isLoading,
        error,
    } = useQuery("targets", fetchTargets)

    const followMutation = useMutation ((id) => {
        const data = {"target":id};
        api.post(`/api/osint/follow/`, data )
        });
    
    const dismissMutation = useMutation ((id) => {
        const data = {"target":id};
        api.delete(`/api/osint/follow/`, data )
        });
    
        const handleFollow = (id) => {
            followMutation.mutate(id)
        };

        const handleDismiss = (id) => {
            dismissMutation.mutate(id)
        };
    
    if (isLoading) return <div>Loading...</div>
    if (error) return <div>Error: {error.message}</div>
    
    return (
        <div className="follows">
        <span>Latest Targets</span>
        {targets.map((target, index) => (
            <div key={index} className="target">
              <Link to={`/target/${target.id}`}>
                <div className="targetInfo">
                  <img
                    src="/images/target_profile_cropped.png"
                    alt=""
                  />
                  <span>{target.name}</span>
                </div>
              </Link>
              {/* <div className="buttons">
                <button onClick={() => handleFollow(target.id)}>follow</button>
                <button onClick={() => handleDismiss(target.id)}>dismiss</button>
              </div> */}
            </div>
          ))}
        </div>
    )
    }

export default FollowList